export default __webpack_public_path__ + "static/media/Group 19.96ed1dde.png";